module.exports = __webpack_public_path__ + "img/angle down.b08dad59.svg";